function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { ECompareType } from '../../../../constants';
import { getStepHistoryItem } from './getStepHistoryItem';
import { StepWizardSchemeError } from '../../../../models';
/**
 * Находит шаг, следующий по отношению к currentStep
 * Если найденный следующий шаг необходимо пропустить, рекурсивно вызовется повторно, пока не найдет подходящий шаг
 * Пропущенные шаги тоже вернет
 * */
export var getNextStep = function getNextStep(params) {
  var _params$answers = params.answers,
    answers = _params$answers === void 0 ? {} : _params$answers,
    _params$currentStep = params.currentStep,
    nextStep = _params$currentStep.nextStep,
    code = _params$currentStep.code,
    _params$skipSteps = params.skipSteps,
    skipSteps = _params$skipSteps === void 0 ? [] : _params$skipSteps,
    scheme = params.scheme;
  var _iterator = _createForOfIteratorHelper(nextStep),
    _step;
  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var rule = _step.value;
      var conditions = rule.conditions,
        nextStepCode = rule.nextStepCode,
        nextStepArgs = rule.nextStepArgs;
      var isRuleCorrect = conditions.every(function (condition) {
        return checkCondition(condition, answers[condition.answerField]);
      });
      if (isRuleCorrect) {
        /** Если указатель на следующий шаг не задан - то значит текущий шаг был последний, следующего нет **/
        if (!nextStepCode) {
          return undefined;
        }

        /**
         * Если следующий шаг - в списке пропускаемых, то рекурсивно находим последующий шаг
         * */
        if (skipSteps.includes(nextStepCode)) {
          var currentStep = getStepHistoryItem({
            stepCode: nextStepCode,
            stepArguments: nextStepArgs,
            scheme: scheme
          });
          return getNextStep({
            scheme: scheme,
            skipSteps: skipSteps,
            answers: answers,
            currentStep: currentStep
          });
        }
        return getStepHistoryItem({
          stepCode: nextStepCode,
          stepArguments: nextStepArgs,
          scheme: scheme
        });
      }
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  throw new StepWizardSchemeError("\u0428\u0430\u0433 ".concat(code, " \u043D\u0435 \u0438\u043C\u0435\u0435\u0442 \u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u043E\u0433\u043E \u043D\u0430\u0431\u043E\u0440\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0434\u043B\u044F \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430 \u0434\u0430\u043B\u044C\u0448\u0435. \u0421\u0445\u0435\u043C\u0430 \u043D\u0435\u043A\u043E\u0440\u0440\u0435\u043A\u0442\u043D\u0430."));
};

/**
 * Утилита проверяет ответ пользователя на соответствие правилу
 * Учитывает разные методы сравнения (condition.compareType) и разные типы ответов юзера (string | array)
 * */
export function checkCondition(condition, value) {
  if (condition.compareType === ECompareType.InList) {
    if (Array.isArray(value)) {
      return value.some(function (el) {
        return condition.value.includes(el);
      });
    }
    return Boolean(value) && condition.value.includes(String(value));
  }
  if (condition.compareType === ECompareType.Eq) {
    if (Array.isArray(value)) {
      return value.length === condition.value.length && value.every(function (el) {
        return condition.value.includes(el);
      });
    }
    return Boolean(value) && String(value) === condition.value[0];
  }
  return false;
}